if (!window.customElements.get('announcement-bar')) {
    class AnnouncementBar extends HTMLElement {
        constructor() {
            super();
            this.scrollY;
            this.template = this.getAttribute('template');
            window.addEventListener('scroll', debounce(this.handleScroll.bind(this), 10));
            this.handleScroll();
        }
        handleScroll() {
            if (this.template == "index") {
                this.scrollY = window.scrollY;
                if (this.scrollY > 0) {
                    this.classList.add('visible');          
                    this.classList.remove('invisible');          
                } else {
                    this.classList.remove('visible');    
                    this.classList.add('invisible');        
                }
            }
        }
    }
    window.customElements.define('announcement-bar', AnnouncementBar);
}

